import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, BeenhereRounded } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import ModalRange from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { currency } from 'hooks/Pipe';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsFindBy } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  /* { Header: 'Periodo', accessor: 'period', width: 100, align: 'center' }, */
  { Header: 'Fec. Periodo', accessor: 'period_date' },
  { Header: 'Rango min.', accessor: 'min_range' },
  { Header: 'Rango máx.', accessor: 'max_range' },
  { Header: 'Monto', accessor: 'bonification_amount' },
  { Header: 'Monto 2', accessor: 'bonification_amount_2' },
  { Header: 'T. comisión', accessor: 'type_comision' },
  { Header: 'T. Efectividad', accessor: 'type_efectivity' },
  { Header: 'Zona', accessor: 'base_zones_description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function Rango(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [ranges, setRanges] = useState([]);
  const [valueSearch, setValueSearch] = useState(undefined);
  const [filter, setFilter] = useState(undefined);
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (e) => {
    setValueSearch({ ...valueSearch, [e.target.name]: e.target.value });
  };

  async function listRange(filter) {
    const search = { ...filter, ...valueSearch };
    setFilter(search);

    for (let clave in search) {
      if (search[clave] == null || search[clave] == '') {
        delete search[clave];
      }
    }
    setDataLoading(true);
    let response = await wsFindBy('com/range', search);
    setDataLoading(false);
    if (response.success) setRanges(response.data);
  }

  useEffect(() => {
    if (valueSearch) listRange(filter);
  }, [valueSearch]);

  return (
    <>
      <Toasty action={notify} />
      <ModalRange
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => listRange(filter)}
      />
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.COM_RANGES_STORE}
            component={
              <CardIcon color="primary">
                <BeenhereRounded style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado de rangos {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <FilterCustom
            getFilter={listRange}
            date
            dateType="month"
            labelDate="Periodo"
            dateField="period_date"
            zone
            commissions={[
              { key: 'R', label: 'Jefe reparto' },
              { key: 'M', label: 'Encargado mercadería' },
              { key: 'V', label: 'Vendedor' },
              { key: 'S', label: 'Supervisor' }
            ]}
            commissionField="type_comision"
            component={
              <GridItem xs={12} md={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Tipo efectvidad</InputLabel>
                  <Select
                    defaultValue=""
                    inputProps={{ name: 'type_efectivity' }}
                    onChange={handleChange}
                  >
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="P">Pedidos</MenuItem>
                    <MenuItem value="S">Soles</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
            }
          />

          <ReactTable
            excelName="Rangos"
            formatDate="DD-MM-YYYY"
            defaultWidth={1200}
            columns={columns}
            data={ranges.map((item, i) => {
              let commission = '-';
              let efectivity = '-';

              switch (item.type_comision) {
                case 'R':
                  commission = 'Jefe reparto';
                  break;
                case 'M':
                  commission = 'Encargado mercadería';
                  break;
                case 'V':
                  commission = 'Vendedor';
                  break;
                case 'S':
                  commission = 'Supervisor';
                  break;
                default:
                  commission = '-';
                  break;
              }

              switch (item.type_efectivity) {
                case 'P':
                  efectivity = 'Pedidos';
                  break;
                case 'S':
                  efectivity = 'Soles';
                  break;
                default:
                  efectivity = '-';
                  break;
              }

              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.COM_RANGES_UPDATE}>
                      <Button justIcon round simple color="info" onClick={() => setOpen(item)}>
                        <Create />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.COM_RANGES_DELETED}>
                      <ButtonDelete
                        entity="com/range"
                        id={item.id}
                        reload={() => listRange(filter)}
                      />
                    </AllowedGuard>
                  </div>
                ),
                /* period: item.period, */
                period_date: item.period_date,
                min_range: item.min_range,
                max_range: item.max_range,
                bonification_amount: currency(item.bonification_amount),
                bonification_amount_2: currency(item.bonification_amount_2),
                type_comision: commission,
                type_efectivity: efectivity,
                base_zones_description: item.base_zones_description,
                state: item.state === 'A' ? 'Activo' : 'Inactivo',
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
